var map = {
	"./amex-large.svg": "wqIQ",
	"./amex-stacked.png": "YTIi",
	"./amex-stacked.svg": "DVxv",
	"./amex.jpg": "OU38",
	"./cal-diners-stacked.png": "jOYd",
	"./cal-diners-stacked.svg": "HQZE",
	"./cal-diners.png": "YAXe",
	"./cal-stacked.png": "fyxA",
	"./cal.jpg": "JujK",
	"./discount-large.svg": "oZmj",
	"./discount-small.svg": "nf9v",
	"./discount.jpg": "BG/k",
	"./doar-large.svg": "fnBv",
	"./doar.jpg": "xi+F",
	"./egud.jpg": "ZIKI",
	"./habeinleumi-large.svg": "wZ7I",
	"./habeinleumi-small.svg": "UjqK",
	"./habenleumi.jpg": "KdQj",
	"./hapoalim-large.svg": "GciT",
	"./hapoalim-small.svg": "8NCj",
	"./igud-large.svg": "62Os",
	"./igud-small.svg": "owgu",
	"./isracard-large.svg": "bBSK",
	"./isracard-stacked.svg": "j6UR",
	"./isracard.jpg": "rd70",
	"./jerusalem-large.jpg": "iFOQ",
	"./jerusalem.jpg": "Yi4A",
	"./leumi-large.svg": "VD+d",
	"./leumi-small.svg": "ZYEj",
	"./leumi.jpg": "DVpZ",
	"./leumicard-max-stacked.png": "L+4/",
	"./leumicard-max.png": "kiDr",
	"./leumicard-stacked.png": "0v4Y",
	"./leumicard.jpg": "Oqcw",
	"./masad.jpg": "pcrL",
	"./massad-large.svg": "jtcJ",
	"./massad-small.svg": "IhLO",
	"./max-leumi-stacked.svg": "eKd4",
	"./mercantil.jpg": "E7BS",
	"./mercantile-large.png": "ZA7Q",
	"./mizrachi-large.svg": "N1uv",
	"./mizrachi-small.svg": "MXPe",
	"./mizrahi.jpg": "rrIp",
	"./otsar-large.jpg": "Mjt1",
	"./otsar-large.png": "V+ql",
	"./otzarhahayal.jpg": "k5Q3",
	"./pagi-large.png": "Lhm+",
	"./pagi.jpg": "3QWM",
	"./pepper-large.svg": "X3sg",
	"./pepper.png": "95P7",
	"./poalim.jpg": "FW+e",
	"./ubank-large.png": "m4w4",
	"./ubank.jpg": "SEwk",
	"./yahav-large.jpg": "ixFC",
	"./yahav.jpg": "+YWj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+Mxe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos ^\.\/.*$
// module id = +Mxe
// module chunks = 6